module.exports = __webpack_public_path__ + "img/holdback.92ddaa5f.png";